import {Localizer} from "../../../infrastructure/localization/localizer";

export enum DashboardOpmaerksomhedspunkterEnum {
    UddannelseslaegeManglerVejleder = 1,
    UddannelseslaegeManglerAktivitetPaaUddannelsesplan = 2,
    UddannelseslaegeHarKlarmeldteKompetencer = 3,
    UddannelseslaegeHarOverskredetIntroVejledersamtaleFrist = 4,
    UddannelseslaegeHarOverskredetJusterendeVejledersamtaleFrist = 5,
    UddannelseslaegeHarOverskredetAfsluttendeVejledersamtaleFrist = 6,
    UddannelseslaegeManglerAtEvaluereForloeb = 7,
    UddannelseslaegeManglerAtFaaGodkendtForloeb = 8
}

export const GetDescription = (enumItem: DashboardOpmaerksomhedspunkterEnum) => {
    switch (enumItem) {
        case DashboardOpmaerksomhedspunkterEnum.UddannelseslaegeManglerVejleder:
            return Localizer.dashboard_opmaerksomhedspunkt_manglerVejleder();
        case DashboardOpmaerksomhedspunkterEnum.UddannelseslaegeManglerAktivitetPaaUddannelsesplan:
            return Localizer.dashboard_opmaerksomhedspunkt_manglerAktivitetPaaUddannelsesplan();
        case DashboardOpmaerksomhedspunkterEnum.UddannelseslaegeHarOverskredetJusterendeVejledersamtaleFrist:
            return Localizer.dashboard_opmaerksomhedspunkt_overskredetJusterendeVejledersamtale();
        case DashboardOpmaerksomhedspunkterEnum.UddannelseslaegeHarOverskredetAfsluttendeVejledersamtaleFrist:
            return Localizer.dashboard_opmaerksomhedspunkt_overskredetAfsluttendeVejledersamtale();
        case DashboardOpmaerksomhedspunkterEnum.UddannelseslaegeManglerAtEvaluereForloeb:
            return Localizer.dashboard_opmaerksomhedspunkt_manglerAtEvaluereForloeb();
        case DashboardOpmaerksomhedspunkterEnum.UddannelseslaegeManglerAtFaaGodkendtForloeb:
            return Localizer.dashboard_opmaerksomhedspunkt_manglerAtFaaGodkendtTid();
        case DashboardOpmaerksomhedspunkterEnum.UddannelseslaegeHarKlarmeldteKompetencer:
            return Localizer.dashboard_opmaerksomhedspunkt_harKlarmeldteKompetencer();
        case DashboardOpmaerksomhedspunkterEnum.UddannelseslaegeHarOverskredetIntroVejledersamtaleFrist:
            return Localizer.dashboard_opmaerksomhedspunkt_overskredetIntroVejledersamtale();
        default:
            return "";
    }
}
export const GetInfoIconDescription = (enumItem: DashboardOpmaerksomhedspunkterEnum) => {
    switch (enumItem) {
        case DashboardOpmaerksomhedspunkterEnum.UddannelseslaegeHarOverskredetIntroVejledersamtaleFrist:
            return Localizer.dashboard_uddannelseslaegeHarOverskredetIntroVejledersamtaleFristTooltipTekst()
        case DashboardOpmaerksomhedspunkterEnum.UddannelseslaegeHarOverskredetJusterendeVejledersamtaleFrist:
            return Localizer.dashboard_uddannelseslaegeHarOverskredetJusterendeVejledersamtaleFristTooltipTekst()
        case DashboardOpmaerksomhedspunkterEnum.UddannelseslaegeHarOverskredetAfsluttendeVejledersamtaleFrist:
            return Localizer.dashboard_uddannelseslaegeHarOverskredetAfsluttendeVejledersamtaleFristTooltipTekst()
        case DashboardOpmaerksomhedspunkterEnum.UddannelseslaegeManglerVejleder:
            return Localizer.dashboard_uddannelseslaegeManglerVejlederTooltipTekst()
        case DashboardOpmaerksomhedspunkterEnum.UddannelseslaegeManglerAktivitetPaaUddannelsesplan:
            return Localizer.dashboard_uddannelseslaegeManglerAktivitetPaaUddannelsesplanTooltipTekst()
        case DashboardOpmaerksomhedspunkterEnum.UddannelseslaegeManglerAtEvaluereForloeb:
            return Localizer.dashboard_uddannelseslaegeManglerAtEvaluereForloebTooltipTekst()
        case DashboardOpmaerksomhedspunkterEnum.UddannelseslaegeManglerAtFaaGodkendtForloeb:
            return Localizer.dashboard_uddannelseslaegeManglerAtFaaGodkendtTidligereForloebTooltipTekst()
        case DashboardOpmaerksomhedspunkterEnum.UddannelseslaegeHarKlarmeldteKompetencer:
            return Localizer.dashboard_uddannelseslaegeHarKlarmeldteKompetencerTooltipTekst()
        default:
            return undefined;
    }
}

export const GetSubject = (enumItem: DashboardOpmaerksomhedspunkterEnum) => {
    switch (enumItem) {
        case DashboardOpmaerksomhedspunkterEnum.UddannelseslaegeManglerVejleder:
            return Localizer.global_vejledning();
        case DashboardOpmaerksomhedspunkterEnum.UddannelseslaegeManglerAktivitetPaaUddannelsesplan:
            return Localizer.uddannelsesplan();
        case DashboardOpmaerksomhedspunkterEnum.UddannelseslaegeHarOverskredetJusterendeVejledersamtaleFrist:
            return Localizer.vejledersamtaleJusteringssamtale();
        case DashboardOpmaerksomhedspunkterEnum.UddannelseslaegeHarOverskredetAfsluttendeVejledersamtaleFrist:
            return Localizer.vejledersamtaleSlutevalueringssamtale();
        case DashboardOpmaerksomhedspunkterEnum.UddannelseslaegeManglerAtEvaluereForloeb:
            return Localizer.evalueringPage_evalueringer();
        case DashboardOpmaerksomhedspunkterEnum.UddannelseslaegeManglerAtFaaGodkendtForloeb:
            return Localizer.global_tidGodkendt();
        case DashboardOpmaerksomhedspunkterEnum.UddannelseslaegeHarKlarmeldteKompetencer:
            return Localizer.global_kompetencer();
        case DashboardOpmaerksomhedspunkterEnum.UddannelseslaegeHarOverskredetIntroVejledersamtaleFrist:
            return Localizer.vejledersamtaleIntrosamtale();
        default:
            return "";
    }
}
